module.exports = __webpack_public_path__ + "img/3a8821d9e74b97fe0768002866686dca.png";